import type { TrainingVideos } from '@inspiren-monorepo/virtual-care/api-contracts';

import { Api } from '../../../utility/client';

export const getTrainingVideos = async () =>
  Api.get<TrainingVideos>('admin/v1/training-videos').then((res) => res.data);
